var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MobileHomeBanner',{staticClass:"d-lg-none",attrs:{"image-md":_vm.imageMd,"image-sm":_vm.imageSm}}),_c('DeskHomeBanner',{staticClass:"d-none d-lg-block"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }